'use strict';

// IE11/Edge ForEach polyfill.
(function () {
	if (typeof NodeList.prototype.forEach === 'function') return false;
	NodeList.prototype.forEach = Array.prototype.forEach;
})();

// IE11 'Includes' polyfill
if (!String.prototype.includes) {
	String.prototype.includes = function (search, start) {
		if (typeof start !== 'number') {
			start = 0;
		}

		if (start + search.length > this.length) {
			return false;
		} else {
			return this.indexOf(search, start) !== -1;
		}
	};
}

if (!Array.from) {
	Array.from = function (object) {
		'use strict';

		return [].slice.call(object);
	};
}